<template>
  <router-view />
</template>
<script setup>
document.addEventListener('selectstart', (e) => {
  e.preventDefault()
})
window.onload = function () {
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault()
  })
}
</script>
<style lang="scss">
@import "~@/assets/style/App.scss";
@import "~@/assets/style/animate.min.css";
</style>
